import { Document } from '~/types/document';
import { Money } from '~/types/money';
import { isAvere, isDare, isPaidInDare } from '~/utils/bookkeeping/bookkeeping-entry';
import { absMoney, ensureDecimalPlaces, isMoneyLessThan, newMoney, subtractMoney, sumMoney } from '~/utils/money';

const toPay = (document: Document): Money => {
  const {
    bookkeepingEntries,
    grossAmount: { currency },
  } = document;

  if (bookkeepingEntries.length === 0) {
    return ensureDecimalPlaces(newMoney('0', currency), 2);
  }

  const registeredInDare = !isPaidInDare(document);
  const relevantEntries = bookkeepingEntries.filter((entry) => (registeredInDare ? isDare(entry) : isAvere(entry)));

  return ensureDecimalPlaces(
    relevantEntries.reduce((sum, entry) => sumMoney(sum, absMoney(entry.amount)), newMoney('0', currency)),
    2,
  );
};

export const documentPaid = (document: Document): Money => {
  const {
    bookkeepingEntries,
    grossAmount: { currency },
  } = document;

  if (bookkeepingEntries.length === 0) {
    return ensureDecimalPlaces(newMoney('0', currency), 2);
  }

  const paidInDare = isPaidInDare(document);
  const relevantEntries = bookkeepingEntries.filter((entry) => (paidInDare ? isDare(entry) : isAvere(entry)));

  return ensureDecimalPlaces(
    relevantEntries.reduce((sum, entry) => sumMoney(sum, absMoney(entry.amount)), newMoney('0', currency)),
    2,
  );
};

export const documentOutstandingBalance = (document: Document): Money => {
  const totalToPay = toPay(document);
  const totalPaid = documentPaid(document);

  if (isMoneyLessThan(totalToPay, totalPaid)) {
    return ensureDecimalPlaces(newMoney('0', totalToPay.currency), 2);
  }

  return ensureDecimalPlaces(subtractMoney(totalToPay, totalPaid), 2);
};
